exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._-_-src-components-Chat-___miniChat__miniChat___3af_f{position:fixed;bottom:0;right:12%;z-index:1111;display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end}._-_-src-components-Chat-___miniChat__miniChatWindow___1jtfW{max-width:600px}@media screen and (max-width:1024px){._-_-src-components-Chat-___miniChat__miniChat___3af_f{display:none}}", ""]);

// exports
exports.locals = {
	"miniChat": "_-_-src-components-Chat-___miniChat__miniChat___3af_f",
	"miniChatWindow": "_-_-src-components-Chat-___miniChat__miniChatWindow___1jtfW"
};


//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!/var/www/build-health-2/~/postcss-loader!/var/www/build-health-2/src/components/Chat/miniChat.css
// module id = 1352
// module chunks = 0